import { render, staticRenderFns } from "./Batch.vue?vue&type=template&id=53415366&scoped=true"
import script from "./Batch.vue?vue&type=script&lang=js"
export * from "./Batch.vue?vue&type=script&lang=js"
import style0 from "./Batch.vue?vue&type=style&index=0&id=53415366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53415366",
  null
  
)

export default component.exports